import * as React from 'react';
import './sectionHeader.module.scss';
import { SectionSuccinctIndexView } from '../../../types/sections';
import { LessonIndexView } from '../../../types/lessons';

type Props = {
    lesson: LessonIndexView;
    section: SectionSuccinctIndexView;
};

export class SectionHeader extends React.Component<Props> {
    render() {
        const { lesson, section } = this.props;
        return (
            <div styleName="header-wrapper">
                <div styleName="section-header">
                    <div styleName="lesson-title">
                        DAY {lesson.index + 1} {section.index + 1}/{lesson.sections.length}
                    </div>
                    <div styleName="title" id="title">
                        {section.title}
                    </div>
                </div>
            </div>
        );
    }
}
